module.exports = __webpack_public_path__ + "img/gc2.3eb577c1.jpg";